import React from 'react';
import './ActivateButton.scss';
import deactiveicon from '../../assets/images/deactivateIcon.svg';
export function ActivateButton(props) {
  const cls =
    props.state === 'active'
      ? 'btn btn-danger deactivation-btun'
      : 'btn btn-success activation-btun';

  return props.liveProject ? (
    <div className="live-proj-deactivate" onClick={props.onclick}>
      <img src={deactiveicon} />
      <div>{props.label}</div>
    </div>
  ) : (
    <button className={cls} onClick={props.onclick}>
      {props.label}
    </button>
  );
}
